import React from 'react';
import { Grid, Container, Box } from '@material-ui/core';
import Typewriter from 'typewriter-effect';
import SecImg from '../../Attachments/IMN_4863.jpg';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const About_me = () => {
    return (
        <Box sx={{ mt: 4 }} id='about-me'>
            <h1>About <span className='textColor'>Me</span></h1>
            <Container >
                <hr />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <div data-aos="fade-up">
                            <img src={SecImg} width='50%' alt="me" />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6} className='about-me'>
                        <div style={{ display: 'flex' }}>
                            <h4>Name: </h4>
                            <h4
                                style={{ marginLeft: '5px' }}>
                                <span
                                    // id='textColor'
                                    style={{ color: 'rgb(138, 224, 102)' }}>
                                    <Typewriter
                                        options={{
                                            strings: ['Rafiq Ahamed Tanim'],
                                            autoStart: true,
                                            loop: true,
                                            pauseFor: 15000,
                                        }}
                                    />
                                </span>
                            </h4>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <h4>Age: </h4>
                            <h4
                                style={{ marginLeft: '5px' }}>
                                <span
                                    style={{ color: 'rgb(138, 224, 102)' }}>
                                    <Typewriter
                                        options={{
                                            strings: ['24'],
                                            autoStart: true,
                                            loop: true,
                                            pauseFor: 15000,
                                        }}
                                    />
                                </span>
                            </h4>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <h4>Email: </h4>
                            <h4
                                style={{ marginLeft: '5px' }}>
                                <span
                                    style={{ color: 'rgb(138, 224, 102)' }}>
                                    <Typewriter
                                        options={{
                                            strings: ['rafiqahamed.tanim@gmail.com'],
                                            autoStart: true,
                                            loop: true,
                                            pauseFor: 15000,
                                        }}
                                    />
                                </span>
                            </h4>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <h4>Phone: </h4>
                            <h4
                                style={{ marginLeft: '5px' }}>
                                <span
                                    style={{ color: 'rgb(138, 224, 102)' }}>
                                    <Typewriter
                                        options={{
                                            strings: ['+8801759098514'],
                                            autoStart: true,
                                            loop: true,
                                            pauseFor: 15000,
                                        }}
                                    />
                                </span>
                            </h4>
                        </div>
                        {/* <h4 style={{ textAlign: 'center' }}>Skills</h4>
                        <hr />
                        <div>
                            <div><button style={{ padding: '15px' }}><a href=""><FontAwesomeIcon icon="fa-brands fa-square-facebook" /></a></button></div>
                        </div> */}
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default About_me;